import { NOT_FOUND } from '../actions/4xx';

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import userReducer from './users';
import { FETCH_CONTEST_LIST_ERROR, FETCH_CONTEST_LIST_START, FETCH_CONTEST_LIST_SUCCESS } from '../pages/contest';
import { FETCH_CONTEST_ERROR, FETCH_CONTEST_START, FETCH_CONTEST_SUCCESS } from '../pages/contest/Detail';
import authReducer from './auth';
import { CLEAR_MESSAGE, LOGIN, LOGIN_ERROR, LOGIN_SUCCESS, LOGOUT } from '../actions/login';
import lookupReducer from './lookup';
import { FETCH_LEAD, RECEIVE_LEAD } from '../actions/lead';
import leadReducer from './leads';
import reportReducer from './report';
import { SEARCH_COMPLETE, SEARCH_ERROR, START_SEARCH } from '../actions/report';
import reportConfigsReducer from './reportConfig';
import { CLEAR_LOADING, SET_LOADING, SET_MESSAGE } from '../actions/utils';
import { SEARCH_COMPLETE_POLICY, SEARCH_ERROR_POLICY, START_SEARCH_POLICY, START_SEARCH_ISSUED } from '../actions/policy';
import policyReducer from './policy';

const appReducer = (state = { loading: false, message: '', errors: [] }, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: true };

    case CLEAR_LOADING:
      return { ...state, loading: false };

    case FETCH_LEAD:
    case LOGIN:
    case START_SEARCH:
    case START_SEARCH_POLICY:
    case START_SEARCH_ISSUED:
      return { ...state, loading: true };

    case RECEIVE_LEAD:
    case NOT_FOUND:
    case LOGIN_SUCCESS:
    case LOGIN_ERROR:
    case SEARCH_COMPLETE:
    case SEARCH_ERROR:
    case SEARCH_COMPLETE_POLICY:
    case SEARCH_ERROR_POLICY:
    case LOGOUT:
      return { ...state, loading: false };

    case SET_MESSAGE:
      return { ...state, message: action.payload, errors: action.errors };
    case CLEAR_MESSAGE:
      return { ...state, message: '', errors: [], loading: false };

    default:
      return { ...state };
  }
};
const contextReducer = (state = { data: null, byId: {} }, action) => {
  switch (action.type) {
    case FETCH_CONTEST_LIST_START:
    case FETCH_CONTEST_LIST_ERROR:
    case FETCH_CONTEST_START:
    case FETCH_CONTEST_ERROR:
      return state;

    case FETCH_CONTEST_LIST_SUCCESS:
      return { ...state, data: action.payload };

    case FETCH_CONTEST_SUCCESS:
      let data = action.payload;
      let byId = state?.byId || {};
      byId = { ...byId, [data.id]: data };
      return { ...state, byId };

    default:
      return state;
  }
};
const reducer = (history) =>
  combineReducers({
    router: connectRouter(history), // the key must be 'router'
    leads: leadReducer,
    lookup: lookupReducer,
    report: reportReducer,
    auth: authReducer,
    app: appReducer,
    user: userReducer,
    reportConfigs: reportConfigsReducer,
    contest: contextReducer,
    policy: policyReducer,
  });
export default reducer;
